import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App";
import { AuthProvider } from "@/app/AuthContext";
import { I18nProvider } from "@/shared/i18n";
import { PrefsProvider } from "@/shared/lib/prefs";
import "@/styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root elementi topilmadi");

/**
 * Boshlang'ich yuklash ekrani (`index.html` dagi `#boot`) — ilova chizilib,
 * sahifa resurslari yuklangach silliq yopiladi. Tarmoq sekin bo'lsa ham
 * foydalanuvchi uzoq kutib qolmasligi uchun eng ko'pi bilan 4 s turadi.
 */
function closeBootScreen() {
  const boot = document.getElementById("boot");
  if (!boot) return;
  let closed = false;
  const close = () => {
    if (closed) return;
    closed = true;
    boot.classList.add("is-done");
    window.setTimeout(() => boot.remove(), 600);
  };
  if (document.readyState === "complete") window.setTimeout(close, 200);
  else window.addEventListener("load", () => window.setTimeout(close, 150), { once: true });
  window.setTimeout(close, 4000);
}

createRoot(container).render(
  <StrictMode>
    <PrefsProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </PrefsProvider>
  </StrictMode>,
);

closeBootScreen();
